import { render, staticRenderFns } from "./SpecialNotification.vue?vue&type=template&id=c7ba103e&scoped=true&"
import script from "./SpecialNotification.vue?vue&type=script&lang=js&"
export * from "./SpecialNotification.vue?vue&type=script&lang=js&"
import style0 from "./SpecialNotification.vue?vue&type=style&index=0&id=c7ba103e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ba103e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon})
